var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPublishedIndicator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9.18.521.813.894c.32.35.78.541 1.254.52l1.207-.057a1.595 1.595 0 0 1 1.668 1.668l-.056 1.207c-.022.474.168.934.52 1.254l.893.814a1.595 1.595 0 0 1 0 2.358l-.894.814c-.35.32-.541.78-.52 1.254l.057 1.207a1.595 1.595 0 0 1-1.668 1.668l-1.207-.056a1.595 1.595 0 0 0-1.254.52l-.814.893a1.595 1.595 0 0 1-2.358 0l-.814-.894a1.595 1.595 0 0 0-1.254-.52l-1.207.057a1.595 1.595 0 0 1-1.668-1.668l.056-1.207a1.595 1.595 0 0 0-.52-1.254L.522 9.18a1.595 1.595 0 0 1 0-2.358l.894-.814c.35-.32.541-.78.52-1.254l-.057-1.207a1.595 1.595 0 0 1 1.668-1.668l1.207.056c.474.022.934-.168 1.254-.52L6.82.522a1.595 1.595 0 0 1 2.358 0zM10.708 5.5 7.025 8.999 5.291 7.35l-.791.752L7.025 10.5 11.5 6.25l-.791-.75z",
    fill: "#007AFF",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublishedIndicator);
export default __webpack_public_path__ + "static/media/published-indicator.e6e31d258699713016e857401e88a008.svg";
export { ForwardRef as ReactComponent };